import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03911c12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header_hint" }
const _hoisted_3 = { class: "register_btn" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_5 = { class: "register_type" }
const _hoisted_6 = {
  key: 0,
  class: "reset_box"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "reset_title" }, "Reset Your Password", -1))
const _hoisted_8 = { style: {"margin-bottom":"34px"} }
const _hoisted_9 = {
  key: 0,
  class: "hint_box",
  style: {'color':'#e02020'}
}
const _hoisted_10 = { class: "register_btn" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Next")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_phoneEmailVue = _resolveComponent("phoneEmailVue")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: $setup.phone_or_email_bind == 'bind' || $setup.phone_or_email_bind =='register'?'Bind your phone or email':'Forgot Password'
    }, null, 8, ["title"]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString($setup.registerType ? 'Verify Email' : 'Verify phone number'), 1),
      _createVNode(_component_phoneEmailVue, {
        class: "register_box",
        isEmail: $setup.registerType,
        CaptchaType: $setup.phone_or_email_bind =='register'?'2':'1',
        ref: "fromDate",
        Toast: $setup.Toast
      }, null, 8, ["isEmail", "CaptchaType", "Toast"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_button, {
          class: "register_btn",
          color: "#F87622",
          round: "",
          type: "primary",
          onClick: $setup.submitFn,
          disabled: $setup.loading,
          loading: $setup.loading
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick", "disabled", "loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.registerTypeFn && $setup.registerTypeFn(...args)))
        }, _toDisplayString($setup.registerType?'Reset via SMS':'Reset via Email'), 1)
      ])
    ], 512), [
      [_vShow, $setup.resetPassword == false]
    ]),
    ($setup.resetPassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_field, {
              modelValue: $setup.password,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
                _cache[2] || (_cache[2] = ($event: any) => ($setup.verifyLength()))
              ],
              type: $setup.isShowPassword?'text':'password',
              "right-icon": $setup.isShowPassword?'eye':'closed-eye',
              center: "",
              clearable: "",
              onClickRightIcon: $setup.isShowPWFn,
              "left-icon": 'https://image.kilimall.com/kenya/wap/icons/password.png'.webpFilters()
,
              placeholder: "Enter Password"
            }, null, 8, ["modelValue", "type", "right-icon", "onClickRightIcon", "left-icon"]),
            (!$setup.passwordVerify)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Minimum 6 characters required."))
              : _createCommentVNode("", true),
            _createVNode(_component_van_field, {
              modelValue: $setup.conPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.conPassword) = $event)),
              type: $setup.isShowConPassword?'text':'password',
              "left-icon": 'https://image.kilimall.com/kenya/wap/icons/password.png'.webpFilters()
,
              clearable: "",
              "right-icon": !$setup.isShowConPassword?'closed-eye':'eye',
              placeholder: "Password confirm",
              onClickRightIcon: $setup.isShowConPasswordFn
            }, null, 8, ["modelValue", "type", "left-icon", "right-icon", "onClickRightIcon"]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_van_button, {
                class: "register_btn",
                color: "#F87622",
                round: "",
                type: "primary",
                onClick: $setup.resetPasswordFn,
                disabled: $setup.loading,
                loading: $setup.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick", "disabled", "loading"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}